import ApplicationSerializer from '@square/dashboard-data/serializers/application';
import { v4 as uuid } from 'uuid';
export default ApplicationSerializer.extend({
  normalizeResponse(store, primaryModelClass, payload, id, requestType) {
    // eslint-disable-next-line no-param-reassign
    payload = payload.processing_fees_collection.map(processingFee => {
      // eslint-disable-next-line no-param-reassign
      processingFee.id = uuid();
      return processingFee;
    });
    return this._super(store, primaryModelClass, payload, id, requestType);
  }
});